export var AuthDebugFlagNames;
(function (AuthDebugFlagNames) {
    AuthDebugFlagNames["Impersonate"] = "impersonate_user";
    AuthDebugFlagNames["Auto_Logout_Timeout"] = "auto_logout_timeout";
})(AuthDebugFlagNames || (AuthDebugFlagNames = {}));
export const AuthDebugFlags = [
    {
        name: AuthDebugFlagNames.Impersonate,
        hasMetadata: true,
        metadataHint: 'UUID of user to impersonate',
        inputType: 'auto-complete'
    },
    {
        name: AuthDebugFlagNames.Auto_Logout_Timeout,
        hasMetadata: true,
        metadataHint: 'Enter the time in ms'
    }
];
//# sourceMappingURL=debug-flags.js.map